import React, { useEffect, useMemo, useRef, useState } from "react";
import { Button } from "../../components/Button/Button";
import JoditEditor from "jodit-react";
import { CustomTab, CustomTabs } from "../../components/tabs/Tabs";

import useButtonLoader from "../../hooks/UseButtonLoader";
import toast from "react-hot-toast";
import { getCmsDetailApi, updateCmsApi } from "../../services/cms";
import useFullPageLoader from "../../hooks/useFullPageLoader";
import Editor from "./section/Editor";

const CmsManagement = () => {
  const [error, setError] = useState({ data: "" });
  const [cmsData, setCmsData] = useState({ data: "" });
  const [label, setLabel] = useState("Privacy Policy");

  const [buttonref, buttonLoader] = useButtonLoader("Update");
  const [loader, showLoader, hideLoader] = useFullPageLoader();

  const contentTypeValue =
    localStorage.getItem("contentType") || "powerful text";
  const [contentType, setContentType] = useState(contentTypeValue);
  localStorage.setItem("contentType", contentType);

  const [type, setType] = useState(
    contentType === "content" ? "privacy" : "frequency"
  );
  localStorage.setItem("cmsType", type);

  useEffect(() => {
    setType(
      (contentType === "content" ? "privacy" : "frequency") ||
        localStorage.getItem("cmsType")
    );
    setLabel(
      (contentType === "content" ? "Privacy Policy" : "Frequency") ||
        localStorage.getItem("cmsType")
    );
  }, [contentType]);

  return (
    <>
      <div className="WrapperArea">
        <div className="WrapperBox">
          <div className="row">
            <h4 className="col-4">Content Management</h4>
            <div className="col-5">
              <CustomTabs
                value={contentType}
                onChange={(e, section) => {
                  setContentType(section);
                }}
                aria-label="Content"
                variant="fullWidth"
              >
                <CustomTab value="powerful text" label="Powerful Text" />
                <CustomTab value="content" label="Content Management" />
              </CustomTabs>
            </div>
          </div>
          {contentType === "content" ? (
            <div className="col-sm-10 col-form-label mx-auto mt-3">
              <CustomTabs
                value={type}
                onChange={(e, section) => {
                  setType(section);
                  setLabel(e.target.name);
                }}
                aria-label="Content"
                variant="fullWidth"
              >
                <CustomTab
                  value="privacy"
                  label="Privacy Policy"
                  name="Privacy Policy"
                />
                <CustomTab
                  value="terms"
                  label="Terms & Conditions"
                  name="Terms & Conditions"
                />
            
                <CustomTab
                  value="engage"
                  label="How We Engage Together"
                  name="How We Engage Together"
                />
                <CustomTab
                  value="aidagreement"
                  label="Aid Program"
                  name="Aid Program Participant Agreement"
                />
              </CustomTabs>
            </div>
          ) : (
            <div className="col-sm-12 col-form-label mx-auto mt-3">
              <CustomTabs
                value={type}
                onChange={(e, section) => {
                  setType(section);
                  setLabel(e.target.name);
                }}
                aria-label="Content"
                variant="fullWidth"
              >
                <CustomTab
                  value="frequency"
                  label="Frequency"
                  name="The Neptune Frequency"
                />
                <CustomTab
                  value="highlight"
                  label="Highlight"
                  name="Highlights"
                />

                <CustomTab
                  value="refer"
                  label="Refer"
                  name="Refer to admin (Share)"
                />
                <CustomTab
                  value="library"
                  label="Market"
                  name="Market Library"
                />

                <CustomTab value="fund" label="Fund" name="Fund screen" />
                <CustomTab
                  value="apply for aid"
                  label="Aid"
                  name="Apply for Aid"
                />
                <CustomTab
                  value="donation"
                  label="Donation"
                  name="Fund Donation Screen"
                />
              </CustomTabs>
            </div>
          )}
          <div className="row">
            <Editor contentType={contentType} type={type} title={label} />
          </div>
        </div>
      </div>
    </>
  );
};

export default CmsManagement;
